// Общая палитра «Цвета FAKT» для графиков проекта.
// Порядок: базовые 7 → дополнительные 13. Применяется к сериям/слайсам по индексу.
export default [
  '#FF9D00', '#4DAF4A', '#EB5388', '#38B2B2', '#614EE2', '#D3D5D9', '#0033FF',
  '#E23B3B', '#FF6E4E', '#F5C518', '#9DC93B', '#9B3B7C', '#454A54', '#16307A',
  '#29A3E0', '#12A06B', '#B39DDB', '#F7A072', '#8E2A3A', '#8A8B3C',
]
